import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { v4 as uuid } from 'uuid';
import SendMessage from './components/employer/send-message';
import Tags from './components/employer/tags';
import RestrictedAccess from './components/RestrictedAccess';
import CommanFooter from './components/shared/commanFooter';
import Header from './components/shared/header';
import Loader from './components/shared/loader';
import Notification from './components/shared/notification';
import SEOHead from './components/shared/SEOHead';
import routes from './constants/routes';
import { SocketProvider } from './contexts/SocketContext';
import useLocalStorage from './hooks/useLocalStorage';
import { AppRoutes } from './navigation/app-routes';
import { updateUser } from './store/auth/actions';
import { getHeaderData } from './store/employer/actions';
import { updateSpinner } from './store/global/actions';
import {
  DEVICE_ID_COOKIE,
  clearLegacyBareCookies,
  getCookie,
  setCookie,
  setCookieForCrossOrigin
} from './utils/cookie-service';
import { getIpCountry } from './utils/utility';
import { withRouter } from './utils/withRouter';

function App(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useLocalStorage();

  // VTS-593: sweep orphaned pre-fix bare cookies once per load (prod no-op).
  useEffect(() => {
    clearLegacyBareCookies();
  }, []);

  const fetchUserCountry = async () => {
    updateSpinner(true);
    setIsLoading(true);
    const data = await getIpCountry();
    setHasAccess(data);
    updateSpinner(false);
    setIsLoading(false);
  };

  let deviceId = getCookie(DEVICE_ID_COOKIE);
  if (!deviceId) {
    deviceId = uuid().toString();
    setCookieForCrossOrigin(DEVICE_ID_COOKIE, deviceId);
  }

  const { navigate, location, auth, getHeaderData } = props;

  useEffect(() => {
    const notRedirectRoutes = [
      routes.login,
      routes.home,
      routes.forgotPassword,
      routes.thankYou,
      routes.notFound + '/'
    ];
    if (!notRedirectRoutes.includes(location.pathname) && auth?.isAuthenticated === null) {
      setCookie('redirectPath', location?.pathname);
    }
    if (auth.isAuthenticated === true) getHeaderData();
    if (auth.isAuthenticated === false) navigate(routes.login);
    else if (location.pathname.indexOf('login') > -1) navigate(routes.dashboard);
  }, [auth.isAuthenticated]);

  useEffect(() => {
    if (
      process.env.REACT_APP_ALLOWED_HOST !== window.location.hostname &&
      location.pathname !== routes.notFound
    ) {
      setTimeout(() => {
        navigate(routes.notFound);
      }, 50);
    }
    if (
      auth.isAuthenticated &&
      (location.pathname === routes.login || location.pathname === routes.home)
    ) {
      navigate(routes.dashboard);
    }
    setCookie('prev-path', location.pathname);
    window.scrollTo({ behavior: 'instant', left: 0, top: 0 });
  }, [location.pathname, auth.isAuthenticated]);

  const user = getCookie('veriipro-emp-user');
  if (user && !auth.currentUser) {
    const { updateUser } = props;
    updateUser(user);
  }

  /* For Country restriction */
  useEffect(() => {
    fetchUserCountry();
    window.history.scrollRestoration = 'manual';
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  if (!hasAccess) {
    return (
      <div>
        <Header />
        <RestrictedAccess />
        <CommanFooter />
      </div>
    );
  }
  /* End code */

  return (
    <div>
      <SEOHead pathname={location?.pathname} />
      <SocketProvider userId={auth?.currentUser?.id} isAuthenticated={auth?.isAuthenticated}>
        <SendMessage />
        <Tags />
        <Notification />
        <Loader />
        <AppRoutes />
      </SocketProvider>
    </div>
  );
}

export default connect((state) => ({ auth: state.auth }), { updateUser, getHeaderData })(
  withRouter(App)
);
